// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-panel {
  max-width: 900px;
  margin: 0 auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.test-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.test-header h2 {
  color: #333;
  margin: 0;
  font-size: 1.8rem;
}

.test-controls {
  display: flex;
  gap: 1rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.test-results {
  margin-bottom: 2rem;
}

.no-results {
  text-align: center;
  padding: 3rem;
  color: #666;
  background: #f8f9fa;
  border-radius: 12px;
  border: 2px dashed #dee2e6;
}

.test-result {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #dee2e6;
  transition: all 0.3s ease;
}

.test-result:hover {
  transform: translateX(5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.test-result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.test-icon {
  font-size: 1.2rem;
  margin-right: 0.5rem;
}

.test-name {
  font-weight: 600;
  color: #333;
  flex: 1 1;
}

.test-time {
  font-size: 0.8rem;
  color: #666;
  font-family: monospace;
}

.test-message {
  color: #555;
  font-size: 0.9rem;
  line-height: 1.4;
}

/* Test Status Styles */
.test-success {
  border-left-color: #28a745;
  background: linear-gradient(135deg, #f8fff9 0%, #e8f5e8 100%);
}

.test-error {
  border-left-color: #dc3545;
  background: linear-gradient(135deg, #fff8f8 0%, #f8e8e8 100%);
}

.test-warning {
  border-left-color: #ffc107;
  background: linear-gradient(135deg, #fffef8 0%, #f8f5e8 100%);
}

.test-running {
  border-left-color: #17a2b8;
  background: linear-gradient(135deg, #f8feff 0%, #e8f5f8 100%);
  animation: pulse 2s infinite;
}

.test-info {
  border-left-color: #6c757d;
  background: linear-gradient(135deg, #f8f9fa 0%, #e8eaed 100%);
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.7; }
  100% { opacity: 1; }
}

.test-summary {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
}

.summary-stats {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 1rem;
}

.summary-stats span {
  background: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Dark theme support */
.dark-theme .test-panel {
  color: #ffffff;
}

.dark-theme .test-header h2 {
  color: #ffffff;
}

.dark-theme .test-header {
  border-bottom-color: #555;
}

.dark-theme .test-result {
  background: #2d2d2d;
  border-left-color: #555;
}

.dark-theme .test-name {
  color: #ffffff;
}

.dark-theme .test-message {
  color: #bdc3c7;
}

.dark-theme .test-time {
  color: #95a5a6;
}

.dark-theme .no-results {
  background: #3d3d3d;
  border-color: #555;
  color: #bdc3c7;
}

.dark-theme .test-summary {
  background: #3d3d3d;
  border-color: #555;
}

.dark-theme .summary-stats span {
  background: #2d2d2d;
  color: #ffffff;
}

/* Responsive Design */
@media (max-width: 768px) {
  .test-header {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }
  
  .test-controls {
    justify-content: center;
  }
  
  .test-result-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .summary-stats {
    flex-direction: column;
    align-items: center;
  }
  
  .summary-stats span {
    width: 100%;
    text-align: center;
  }
}

/* Animations */
.test-result {
  animation: slideInRight 0.5s ease-out;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/testing/TestPanel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,6DAA6D;AAC/D;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA,eAAe;AACf;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".test-panel {\r\n  max-width: 900px;\r\n  margin: 0 auto;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.test-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 2rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid #e9ecef;\r\n}\r\n\r\n.test-header h2 {\r\n  color: #333;\r\n  margin: 0;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.test-controls {\r\n  display: flex;\r\n  gap: 1rem;\r\n}\r\n\r\n.btn {\r\n  padding: 0.75rem 1.5rem;\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.btn-primary {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n}\r\n\r\n.btn-primary:hover:not(:disabled) {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\r\n}\r\n\r\n.btn-secondary {\r\n  background: #6c757d;\r\n  color: white;\r\n}\r\n\r\n.btn-secondary:hover:not(:disabled) {\r\n  background: #5a6268;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\r\n}\r\n\r\n.test-results {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.no-results {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  color: #666;\r\n  background: #f8f9fa;\r\n  border-radius: 12px;\r\n  border: 2px dashed #dee2e6;\r\n}\r\n\r\n.test-result {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  margin-bottom: 1rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n  border-left: 4px solid #dee2e6;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.test-result:hover {\r\n  transform: translateX(5px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.test-result-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.test-icon {\r\n  font-size: 1.2rem;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.test-name {\r\n  font-weight: 600;\r\n  color: #333;\r\n  flex: 1;\r\n}\r\n\r\n.test-time {\r\n  font-size: 0.8rem;\r\n  color: #666;\r\n  font-family: monospace;\r\n}\r\n\r\n.test-message {\r\n  color: #555;\r\n  font-size: 0.9rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* Test Status Styles */\r\n.test-success {\r\n  border-left-color: #28a745;\r\n  background: linear-gradient(135deg, #f8fff9 0%, #e8f5e8 100%);\r\n}\r\n\r\n.test-error {\r\n  border-left-color: #dc3545;\r\n  background: linear-gradient(135deg, #fff8f8 0%, #f8e8e8 100%);\r\n}\r\n\r\n.test-warning {\r\n  border-left-color: #ffc107;\r\n  background: linear-gradient(135deg, #fffef8 0%, #f8f5e8 100%);\r\n}\r\n\r\n.test-running {\r\n  border-left-color: #17a2b8;\r\n  background: linear-gradient(135deg, #f8feff 0%, #e8f5f8 100%);\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.test-info {\r\n  border-left-color: #6c757d;\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #e8eaed 100%);\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { opacity: 1; }\r\n  50% { opacity: 0.7; }\r\n  100% { opacity: 1; }\r\n}\r\n\r\n.test-summary {\r\n  background: #f8f9fa;\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.summary-stats {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n}\r\n\r\n.summary-stats span {\r\n  background: white;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 20px;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Dark theme support */\r\n.dark-theme .test-panel {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .test-header h2 {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .test-header {\r\n  border-bottom-color: #555;\r\n}\r\n\r\n.dark-theme .test-result {\r\n  background: #2d2d2d;\r\n  border-left-color: #555;\r\n}\r\n\r\n.dark-theme .test-name {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .test-message {\r\n  color: #bdc3c7;\r\n}\r\n\r\n.dark-theme .test-time {\r\n  color: #95a5a6;\r\n}\r\n\r\n.dark-theme .no-results {\r\n  background: #3d3d3d;\r\n  border-color: #555;\r\n  color: #bdc3c7;\r\n}\r\n\r\n.dark-theme .test-summary {\r\n  background: #3d3d3d;\r\n  border-color: #555;\r\n}\r\n\r\n.dark-theme .summary-stats span {\r\n  background: #2d2d2d;\r\n  color: #ffffff;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .test-header {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    align-items: stretch;\r\n  }\r\n  \r\n  .test-controls {\r\n    justify-content: center;\r\n  }\r\n  \r\n  .test-result-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .summary-stats {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n  \r\n  .summary-stats span {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n}\r\n\r\n/* Animations */\r\n.test-result {\r\n  animation: slideInRight 0.5s ease-out;\r\n}\r\n\r\n@keyframes slideInRight {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
